module.exports = __webpack_public_path__ + "img/station-array-default.c106e967.png";